<div *ngIf="thermo === null || thermo === undefined || thermo.on_line === undefined || thermo.on_line !== 1"
	class="grid m-0">
	<div class="col-12 py-2 bg-red-200 text-color flex align-items-center justify-content-center border-round-xl">
		{{ 'OFFLINE_NOT_REACHABLE_THERMO' | translate }}
	</div>
</div>

<form *ngIf="thermo && thermo.on_line === 1" [formGroup]="thermoForm" class="w-full">
	<div class="grid">
		<!-- TEMP & THERMO CONTROLS SEASONS -->
		<div class="col-12 flex justify-content-center">
			<div class="flex flex-column" [ngClass]="getBorderColor()">
				<div class="flex flex-row align-items-center justify-content-around gap-6 pt-2 px-3">
					<!-- MODALITY: FIRST FIELD -->
					<div *ngIf="thermo.current_season ==='winter'" class="flex align-items-center">
						<i class="pi cm-snow text-2xl text-primary pr-2"></i>
						{{ 'MODALITY' | translate }}: {{ 'TH_WINTER' | translate }}
					</div>
					<div *ngIf="thermo.current_season ==='summer'" class="flex align-items-center">
						<i class="pi cm-sun text-2xl text-red-600 pr-2"></i>
						{{ 'MODALITY' | translate }}: {{ 'TH_SUMMER' | translate }}
					</div>
					<div *ngIf="thermo.current_season ==='antifreeze'" class="flex align-items-center">
						<i class="pi cm-antifreeze text-2xl text-primary pr-2"></i>
						{{ 'MODALITY' | translate }}: {{ 'TH_ANTIFREEZE' | translate }}
					</div>
					<!-- RELAY: CENTRAL / SECOND FIELD -->
					<div *ngIf="thermo.relay_status === 1" class="flex align-items-center">
						<i class="pi cm-termo text-2xl pr-2"
							[class]="thermo.current_season ==='summer' ? 'text-primary' : 'text-red-600'">
							<!-- summer -> color blue because is A/C fresh, winter -> color red because is warm air -->
						</i>
						<div [class]="thermo.current_season ==='summer' ? 'text-primary' : 'text-red-600'">{{ 'RELAY_ON' |
							translate }}</div>
					</div>
					<div *ngIf="thermo.relay_status === 0" class="flex align-items-center">
						<i class="pi cm-termo text-2xl text-0 pr-2"></i>
						{{ 'TH_OFF' | translate }}
					</div>
					<!-- HUMIDITY: THIRD FIELD -->
					<div class="flex align-items-center">
						<i class="pi pi-cloud text-2xl text-primary pr-2"></i>
						{{ "HUMIDITY" | translate }}:
						{{ thermo.hum_loc === undefine ? '- %' : thermo.hum_loc + ' %' }}
					</div>
				</div>
				<div class="flex flex-column py-4 w-full">
					<div class="temp-att-val flex justify-content-center text-7xl">
						{{ thermo.temp_loc + ' °C' }}
					</div>
					<div class="temp-att-txt flex justify-content-center">
						{{ 'CURRENT_TEMPERATURE' | translate }}
					</div>
				</div>
			</div>
		</div>

		<!-- DIVIDER -->
		<div class="col-12">
			<div class="flex border-bottom-2 text-900 py-0 mx-3"></div>
		</div>

		<!-- SEASON_CONTROL -->
		<div class="col-12">
			<div class="flex align-items-center justify-content-center text-lg">
				{{ 'SEASON_CONTROL' | translate }}
			</div>
			<div class="flex flex-row align-items-center justify-content-center pt-2">
				<p-selectButton [options]="seasonControlOptions" formControlName="seasonControl"
					(onChange)="seasonControlChanged()" optionValue="value">
					<ng-template let-item pTemplate>
						<div class="flex align-items-center justify-content-center gap-2"
							[class]="!onExtendedMobile() ? 'w-10rem' : ''">
							<i [class]="item.icon"></i>
							<span>{{item.name}}</span>
						</div>
					</ng-template>
				</p-selectButton>
			</div>
		</div>

		<!-- STD / B&B -->
		<div *ngIf="isVisibileBnBModalityControl()" class="col-12">
			<div class="flex align-items-center justify-content-center text-lg gap-2">
				{{ 'TH_MODE' | translate }}
				<p-button *ngIf="!onExtendedMobile()" pTooltip="{{ 'TH_B&B_TOOLTIP' | translate }} {{ 'TH_B&B_OFF_TOOLTIP' | translate }}"
					tooltipPosition="right" icon="pi cm-info" size="large" [rounded]="false" [text]="true"
					severity="primary">
				</p-button>
			</div>
			<div class="flex flex-row align-items-center justify-content-center pt-2">
				<p-selectButton [options]="bnbModalityControlOptions" formControlName="bnbModalityControl" optionValue="value"
					(onChange)="bnbControlChanged()" optionDisabled="disabled">
					<ng-template let-item pTemplate>
						<div class="flex align-items-center justify-content-center gap-2"
							[class]="!onExtendedMobile() ? 'w-10rem' : 'w-5rem'">
							<i [class]="item.icon"></i>
							<span>{{item.name}}</span>
						</div>
					</ng-template>
				</p-selectButton>
			</div>
		</div>

		<!-- THERMAL_CONTROL (off, manual, auto etc.)-->
		<!-- is visible also for THOne BnB in Standard mode -->
		<div *ngIf="isVisibileThermalControl()" class="col-12">
			<div class="flex align-items-center justify-content-center text-lg gap-2">
				{{ 'THERMAL_CONTROL' | translate }}
				<p-button *ngIf="!onExtendedMobile()" pTooltip="{{'NOT_ALL_FUNCTIONS_AVAILABLE_ON_THIS_PLATFORM' | translate }}"
					tooltipPosition="right" icon="pi cm-info" size="large" [rounded]="false" [text]="true"
					severity="primary">
				</p-button>
			</div>
			<div class="flex flex-row align-items-center justify-content-center pt-2">
				<p-selectButton [options]="thermalControlOptions" formControlName="thermalControl" optionValue="value"
					(onChange)="thermalControlChanged()" optionDisabled="disabled">
					<ng-template let-item pTemplate>
						<div class="flex align-items-center justify-content-center gap-2"
							[class]="!onExtendedMobile() ? 'w-10rem' : 'w-5rem'">
							<i [class]="item.icon"></i>
							<span>{{item.name}}</span>
						</div>
					</ng-template>
				</p-selectButton>
			</div>
		</div>

		<!-- MANUAL NORMAL THERMO SET -->
		<div *ngIf="isVisibleManualControlTemperature()" class="col-12 pt-3">
			<!-- <div class="flex align-items-center justify-content-center text-lg pb-2">
					{{'SET_TEMPERATURE' | translate }}
				</div> -->
			<div class="flex justify-content-center">
				<div class="flex flex-column">
					<p-knob id="set-temperature" formControlName="temperature" size="250"
						[min]="thManualTempMin" [max]="thManualTempMax" [step]="thManualTempStepsValue"
						class="cursor-pointer" valueTemplate="{{spinnerManualTemp}}°C" textColor="var(--text-color, Black)"
						valueColor="#00B0ED" rangeColor="#CED1D4"
						(onChange)="sliderTempStop($event, sliderType.MANUAL_TEMP)">
					</p-knob>
					<div class="flex flex-row justify-content-between px-6">
						<p-button icon="pi cm-minus" severity="primary" [rounded]="false" [text]="false"
							(click)="setSliderButtonValue(buttonsTempSet.DECREASE, sliderType.MANUAL_TEMP)"
							[disabled]="isSliderMinMax('min', sliderType.MANUAL_TEMP)" />
						<p-button icon="pi cm-plus" severity="primary" [rounded]="false" [text]="false"
							(click)="setSliderButtonValue(buttonsTempSet.INCREASE, sliderType.MANUAL_TEMP)"
							[disabled]="isSliderMinMax('max', sliderType.MANUAL_TEMP)" />
					</div>
				</div>
			</div>
		</div>

		<!-- BNB_THERMAL_CONTROL (off, manual) -->
		<!-- visible only for THOne BnB in BnB mode -->
		<div *ngIf="isVisibileBnBThermalControl()" class="col-12 pb-4">
			<div class="flex align-items-center justify-content-center text-lg">
				{{ 'THERMAL_CONTROL_B&B' | translate }}
			</div>
			<div class="flex flex-row align-items-center justify-content-center pt-2">
				<p-selectButton [options]="bnbThermalControlOptions" formControlName="bnbThermalControl" optionValue="value"
					(onChange)="bnbThermalControlChanged()" optionDisabled="disabled">
					<ng-template let-item pTemplate>
						<div class="flex align-items-center justify-content-center gap-2"
							[class]="!onExtendedMobile() ? 'w-10rem' : ''">
							<i [class]="item.icon"></i>
							<span>{{item.name}}</span>
						</div>
					</ng-template>
				</p-selectButton>
			</div>
		</div>

		<!-- BNB MANUAL THERMO SET -->
		<div *ngIf="isVisibleBnBManualControlTemperature()" [class]="!underTablet() ? 'col-8' : 'col-12'">
			<div class="flex align-items-center justify-content-center text-lg font-medium gap-2">
				<div class="pi pi-home"></div>
				{{ 'B&B' | translate }}
				<p-button *ngIf="!onExtendedMobile()" pTooltip="{{ 'TH_B&B_MANUAL_TOOLTIP' | translate }}"
					tooltipPosition="right" icon="pi cm-info" size="large" [rounded]="false" [text]="true"
					severity="primary">
				</p-button>
			</div>
			<div class="border-2 border-900 border-round">
				<!-- DELTA NEGATIVE / POSITIVE LINE SLIDER -->
				<div class="grid mt-0">
					<!-- DELTA NEGATIVE LINE SLIDER -->
					<div [class]="col6ResponsiveNoPadding()">
						<div class="flex flex-row align-items-center justify-content-center text-lg gap-2">
							<div>&Delta;<i class="pi cm-minus"></i></div>
							{{ 'DELTA_NEGATIVE' | translate }}
						</div>
						<div class="flex flex-row align-items-center justify-content-center pt-3">
							<div class="flex w-40rem">
								<p-button pTooltip="{{ 'DECREASE' | translate }}" [disabled]="isSliderMinMax('min', sliderType.BnB_DELTA_NEGATIVE)" tooltipPosition="bottom"
									icon="pi cm-minus" size="large" (click)="setSliderValue(-1,'bnbDeltaTempNegative')" [rounded]="false" [text]="true" severity="primary"
									class="pr-3">
								</p-button>
								<div>{{formattedSliderMin()}}</div>

								<div class="flex flex-column w-full mx-4">
									<p-inputNumber mode="decimal" [useGrouping]="false" variant="filled" formControlName="bnbDeltaTempNegative"
										class="flex w-full" styleClass="flex w-full" [min]="thMinValueDelta" [max]="thMaxValueDelta" [step]="thDeltaStepsValue"
										minFractionDigits="1" maxFractionDigits="1"
										(onBlur)="onChangeSlider('bnbDeltaTempNegative')">
									</p-inputNumber>
									<p-slider formControlName="bnbDeltaTempNegative" class="w-full" [min]="thMinValueDelta" [max]="thMaxValueDelta" [step]="thDeltaStepsValue"
										(onSlideEnd)="onChangeSlider('bnbDeltaTempNegative')">
									</p-slider>
								</div>

								<div>{{ formattedSliderMax() }}</div>
								<p-button pTooltip="{{ 'INCREASE' | translate}}" [disabled]="isSliderMinMax('max', sliderType.BnB_DELTA_NEGATIVE)" tooltipPosition="bottom"
									icon="pi cm-plus" size="large" (click)="setSliderValue(1,'bnbDeltaTempNegative')" [rounded]="false" [text]="true" severity="primary"
									class="pl-3">
								</p-button>
							</div>
						</div>
					</div>
					<!-- DELTA POSITIVE LINE SLIDER -->
					<div [class]="col6ResponsiveNoPadding()">
						<div class="flex flex-row align-items-center justify-content-center w-full text-lg gap-2">
							<div>&Delta;<i class="pi cm-plus"></i></div>
							{{ 'DELTA_POSITIVE' | translate }} &Delta;
						</div>
						<div class="flex flex-row align-items-center justify-content-center w-full pt-3">
							<div class="flex w-40rem">
								<p-button pTooltip="{{ 'DECREASE' | translate }}" [disabled]="isSliderMinMax('min', sliderType.BnB_DELTA_POSITIVE)" tooltipPosition="bottom"
									icon="pi cm-minus" size="large" (click)="setSliderValue(-1,'bnbDeltaTempPositive')" [rounded]="false" [text]="true" severity="primary"
									class="pr-3">
								</p-button>
								<div>{{formattedSliderMin()}}</div>

								<div class="flex flex-column w-full mx-4">
									<p-inputNumber mode="decimal" [useGrouping]="false" variant="filled" formControlName="bnbDeltaTempPositive"
										class="flex w-full" styleClass="flex w-full" [min]="thMinValueDelta" [max]="thMaxValueDelta" [step]="thDeltaStepsValue"
										minFractionDigits="1" maxFractionDigits="1"
										(onBlur)="onChangeSlider('bnbDeltaTempPositive')">
									</p-inputNumber>
									<p-slider formControlName="bnbDeltaTempPositive" class="w-full" [min]="thMinValueDelta" [max]="thMaxValueDelta" [step]="thDeltaStepsValue"
										(onSlideEnd)="onChangeSlider('bnbDeltaTempPositive')">
									</p-slider>
								</div>

								<div>{{ formattedSliderMax() }}</div>
								<p-button pTooltip="{{ 'INCREASE' | translate}}" [disabled]="isSliderMinMax('max', sliderType.BnB_DELTA_POSITIVE)" tooltipPosition="bottom"
									icon="pi cm-plus" size="large" (click)="setSliderValue(1,'bnbDeltaTempPositive')" [rounded]="false" [text]="true" severity="primary"
									class="pl-3">
								</p-button>
							</div>
						</div>
					</div>
				</div>
				<!-- BnB MIN INFO, SLIDER, MAX INFO -->
				<div class="grid flex align-items-center mt-0">
					<!-- BnB MIN INFO MOBILE -->
					<div *ngIf="onExtendedMobile()" class="col-6 flex justify-content-end">
						<div class="flex flex-column w-16rem">
							<div class="flex align-items-center justify-content-center text-lg">{{ 'MIN_VAR_AVAILABLE' | translate }}</div>
							<div class="flex align-items-center justify-content-center text-5xl">
								<div>{{getRealTimeMinMaxTempBnB('negative')}}°C</div>
							</div>
						</div>
					</div>
					<!-- BnB MAX INFO MOBILE -->
					<div *ngIf="onExtendedMobile()" class="col-6 flex justify-content-start">
						<div class="flex flex-column w-16rem">
							<div class="flex align-items-center justify-content-center text-lg">{{ 'MAX_VAR_AVAILABLE' | translate }}</div>
							<div class="flex align-items-center justify-content-center text-5xl font-normal">
								<div>{{getRealTimeMinMaxTempBnB('positive')}}°C</div>
							</div>
						</div>
					</div>

					<!-- BnB MIN INFO DESKTOP / TABLET -->
					<div *ngIf="!onExtendedMobile()" class="col-4 flex justify-content-end">
						<div class="flex flex-column w-16rem">
							<div class="flex align-items-center justify-content-center text-lg">{{ 'MIN_VAR_AVAILABLE' | translate }}</div>
							<div class="flex align-items-center justify-content-center text-5xl">
								<div>{{getRealTimeMinMaxTempBnB('negative')}}°C</div>
							</div>
						</div>
					</div>
					<!-- SETPOINT BnB ROUND SLIDER -->
					<div [class]="onExtendedMobile() ? 'col-12' : 'col-4'">
						<div class="flex flex-column align-items-center justify-content-center">
							<p-knob id="set-temperature-b&b" formControlName="bnbTemperature" size="250" [min]="thBnBTempMin"
								[max]="thBnBTempMax" [step]="thBnBTempStepsValue"
								class="cursor-pointer" valueTemplate="{{spinnerBnB}}°C" textColor="var(--text-color, Black)"
								valueColor="#00B0ED" rangeColor="#CED1D4" (onChange)="sliderTempStop($event, sliderType.BnB_MANUAL_TEMP)">
							</p-knob>
							<div class="flex align-items-center justify-content-around w-18rem">
								<p-button icon="pi cm-minus" severity="primary" [rounded]="false" [text]="false"
									(click)="setSliderButtonValue(buttonsTempSet.DECREASE, sliderType.BnB_MANUAL_TEMP)"
									[disabled]="isSliderMinMax('min', sliderType.BnB_MANUAL_TEMP)" />
								<p-button icon="pi cm-plus" severity="primary" [rounded]="false" [text]="false"
									(click)="setSliderButtonValue(buttonsTempSet.INCREASE, sliderType.BnB_MANUAL_TEMP)"
									[disabled]="isSliderMinMax('max', sliderType.BnB_MANUAL_TEMP)" />
							</div>
						</div>
					</div>
					<!-- BnB MAX INFO DESKTOP / TABLET -->
					<div *ngIf="!onExtendedMobile()" class="col-4 flex justify-content-start">
						<div class="flex flex-column w-16rem">
							<div class="flex align-items-center justify-content-center text-lg">{{ 'MAX_VAR_AVAILABLE' | translate }}</div>
							<div class="flex align-items-center justify-content-center text-5xl font-normal">
								<div>{{getRealTimeMinMaxTempBnB('positive')}}°C</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- BNB MANUAL Q&E -->
		<div *ngIf="isVisibleBnBManualControlTemperature()" [class]="!underTablet() ? 'col-4' : 'col-12'">
			<div class="flex align-items-center justify-content-center text-lg font-medium py-1 mb-1 gap-2">
				<div class="pi cm-quick-easy text-lg"></div>
				{{ 'PERMISSIONS' | translate }} {{ 'QUICK_EASY' | translate }}
			</div>
			<div class="border-2 border-900 border-round mt-0">
				<div class="grid m-0">
					<div class="col-12">
						<div class="flex justify-content-between flex-wrap border-bottom-1 border-900"
							[ngClass]="dynamicInputTextFormat('borderRow')">
							<div class="flex align-items-center justify-content-center" [ngClass]="dynamicInputTextFormat('label')">
								{{ 'PERMISSIONS' | translate }} {{ 'QUICK_EASY' | translate }}
							</div>
							<div class="flex align-items-center justify-content-center" [ngClass]="dynamicInputTextFormat('borderInput')">
								<p-inputSwitch inputId="th-quickeasy-enable-switch" formControlName="qneControl"
									(onChange)="quickEasyEnableControlChanged()"></p-inputSwitch>
							</div>
						</div>
					</div>
					<!-- <div class="col-12">
						<div class="flex justify-content-between flex-wrap border-bottom-1 border-900"
							[ngClass]="dynamicInputTextFormat('borderRow')">
							<div class="flex align-items-center justify-content-center gap-2" [ngClass]="dynamicInputTextFormat('label')">
								{{ 'MIN_VAR_AVAILABLE_PERMISSIONS_QE' | translate }}
								<p-button pTooltip="{{'PINCODE_INFO_TOOLTIP' | translate }}" tooltipPosition="bottom" icon="pi cm-info"
									size="large" [rounded]="false" [text]="true" severity="primary">
								</p-button>
							</div>
							<div class="flex align-items-center justify-content-center" [ngClass]="dynamicInputTextFormat('borderInput')">
								<div class="font-medium">{{getRealTimeMinMaxTempBnB('negative')}}°C</div>
							</div>
						</div>
					</div>
					<div class="col-12">
						<div class="flex justify-content-between flex-wrap border-bottom-1 border-900"
							[ngClass]="dynamicInputTextFormat('borderRow')">
							<div class="flex align-items-center justify-content-center gap-2" [ngClass]="dynamicInputTextFormat('label')">
								{{ 'TEMPERATURE_PERMISSIONS_QE' | translate }}
								<p-button pTooltip="{{'PINCODE_INFO_TOOLTIP' | translate }}" tooltipPosition="bottom" icon="pi cm-info"
									size="large" [rounded]="false" [text]="true" severity="primary">
								</p-button>
							</div>
							<div class="flex align-items-center justify-content-center" [ngClass]="dynamicInputTextFormat('borderInput')">
								<div class="font-medium">{{ thermo.bb.temp }}°C</div>
							</div>
						</div>
					</div>
					<div class="col-12">
						<div class="flex justify-content-between flex-wrap border-bottom-1 border-900"
							[ngClass]="dynamicInputTextFormat('borderRow')">
							<div class="flex align-items-center justify-content-center gap-2" [ngClass]="dynamicInputTextFormat('label')">
								{{ 'MAX_VAR_AVAILABLE_PERMISSIONS_QE' | translate }}
								<p-button pTooltip="{{'PINCODE_INFO_TOOLTIP' | translate }}" tooltipPosition="bottom" icon="pi cm-info"
									size="large" [rounded]="false" [text]="true" severity="primary">
								</p-button>
							</div>
							<div class="flex align-items-center justify-content-center" [ngClass]="dynamicInputTextFormat('borderInput')">
								<div class="font-medium">{{getRealTimeMinMaxTempBnB('positive')}}°C</div>
							</div>
						</div>
					</div> -->
					<!-- QE COURTESY_TIME -->
					<div *ngIf="isVisibleQnEControls()" class="col-12 pt-0">
						<div class="flex flex-row align-items-center justify-content-center text-lg gap-2">
							<div class="pi pi-stopwatch"></div>
							{{ 'COURTESY_TIME_MINUTES' | translate }}
							<p-button *ngIf="!onExtendedMobile()" pTooltip="{{ 'TH_Q&E_TIME_COURTESY_TOOLTIP' | translate }}"
								tooltipPosition="top" icon="pi cm-info" size="large" [rounded]="false" [text]="true"
								severity="primary">
							</p-button>
						</div>
						<div class="flex flex-row align-items-center justify-content-center pt-1">
							<div class="flex w-40rem">
								<p-button pTooltip="{{ 'DECREASE' | translate }}" [disabled]="isTimeCourtesySliderMin()"
									tooltipPosition="bottom" icon="pi cm-minus" size="large" (click)="setSliderTimeCourtesyValue(-1)"
									[rounded]="false" [text]="true" severity="primary" class="pr-3">
								</p-button>
								<div>{{ thQeMinValue }}</div>

								<div class="flex flex-column w-full mx-4">
									<p-inputNumber mode="decimal" [useGrouping]="false" variant="filled" formControlName="qneCourtesyTime"
										class="flex w-full" styleClass="flex w-full" [min]="thQeMinValue" [max]="thQeMaxValue" [step]="thQeTimeStepsValue"
										(onBlur)="onChangeSliderTimeCourtesy()">
									</p-inputNumber>
									<p-slider formControlName="qneCourtesyTime" class="w-full" [step]="thQeTimeStepsValue" [min]="thQeMinValue" [max]="thQeMaxValue"
										(onSlideEnd)="onChangeSliderTimeCourtesy()">
									</p-slider>
								</div>

								<div>{{ thQeMaxValue }}</div>
								<p-button pTooltip="{{ 'INCREASE' | translate}}" [disabled]="isTimeCourtesySliderMax()"
									tooltipPosition="bottom" icon="pi cm-plus" size="large" (click)="setSliderTimeCourtesyValue(1)"
									[rounded]="false" [text]="true" severity="primary" class="pl-3">
								</p-button>
							</div>
						</div>
					</div>
					<!-- QE STANDBY TEMP -->
					<div *ngIf="isVisibleQnEControls()" class="col-12 pt-2">
						<div class="flex flex-row align-items-center justify-content-center text-lg gap-2">
							<div class="pi cm-termo"></div>
							{{ 'STANDBY_TEMP' | translate }}
							<p-button *ngIf="!onExtendedMobile()" pTooltip="{{ 'TH_Q&E_STANDBY_TOOLTIP' | translate }}"
								tooltipPosition="bottom" icon="pi cm-info" size="large" [rounded]="false" [text]="true"
								severity="primary">
							</p-button>
						</div>
						<div class="flex flex-column align-items-center justify-content-center">
							<p-knob id="set-temperature-b&b" formControlName="qneTemperature" size="180" [min]="thQuickEasyTempMin"
								[max]="thQuickEasyTempMax" [step]="thQuickEasyTempStep" class="cursor-pointer" valueTemplate="{{spinnerQnEStandby}}°C"
								textColor="var(--text-color, Black)" valueColor="#00B0ED" rangeColor="#CED1D4"
								(onChange)="sliderTempStop($event, sliderType.QnE_STANDBY_TEMP)">
							</p-knob>
							<div class="flex align-items-center justify-content-around w-18rem">
								<p-button icon="pi cm-minus" severity="primary" [rounded]="false" [text]="false"
									(click)="setSliderButtonValue(buttonsTempSet.DECREASE, sliderType.QnE_STANDBY_TEMP)"
									[disabled]="isSliderMinMax('min', sliderType.QnE_STANDBY_TEMP)" />
								<p-button icon="pi cm-plus" severity="primary" [rounded]="false" [text]="false"
									(click)="setSliderButtonValue(buttonsTempSet.INCREASE, sliderType.QnE_STANDBY_TEMP)"
									[disabled]="isSliderMinMax('max', sliderType.QnE_STANDBY_TEMP)" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</form>